export default __webpack_public_path__ + "static/media/khemi.57382d96.jpg";